import React from "react";
import { useModal } from "../../../../hooks";
import { JobOfferPayload } from "../../../../models/candidate-action.model";
import { jobOfferStatusTypes } from "../../../../models/candidate.model";
import { Container, JobOfferUnlocked, ShowJobOffer } from "./job-offer.styled";
import Resume from "./resume";
import useRootTranslation from "../../../../hooks/use-root-translation";

interface JobOfferProps {
  isLocked: boolean;
  joboffer: {
    status: jobOfferStatusTypes;
    metadata: JobOfferPayload;
  };
}

const JobOfferTalentStatus: React.FC<JobOfferProps> = ({
  isLocked,
  joboffer,
}) => {
  const { isShown, toggle } = useModal();
  const { root } = useRootTranslation("talent", "private-home-page");

  return (
    <Container>
      {!isLocked && (
        <JobOfferUnlocked>
          <Resume isShown={isShown} joboffer={joboffer} toggle={toggle} />
          <ShowJobOffer onClick={() => toggle()}>
            {root('jobSummary')}
            <img src="/assets/img/show-more.svg" alt={root('jobSummary')} />
          </ShowJobOffer>
        </JobOfferUnlocked>
      )}
    </Container>
  );
};

export default JobOfferTalentStatus;
